import { Component, Input } from '@angular/core';
import { RouterService } from 'src/app/services/router-service.service';
import { MessageTone } from '../../classes/MessageTone';

@Component({
	selector: 'app-alert',
	templateUrl: './alert.component.html',
	styleUrls: ['./alert.component.scss']
})
export class AlertComponent {

	@Input() innerHTML! : string;
	@Input() tone : MessageTone = "warning";
	@Input() icon! : string;
	@Input() classes = "";

	constructor(private routerService:RouterService) {}

	// Para poder usar href en lugar de routerLink, que no anda por innerHTML
	processLinks($event:any) {
		const element: HTMLElement = $event.target;
		if (element.nodeName === 'A') {
			$event.preventDefault();
			const link = element.getAttribute('href');
			if (link)
				this.routerService.toUrl(link);
		}
	}
}